import { useState } from "react";
import "../styles/Filters.css";
import Select from "./Select";

const CostCenterFilterDropdown = ({
  options = [],
  filterName = "costCenterIdFilter",
  searchFilters,
  setSearchFilters,
  closeFilter,
  columnName = "Cost Center",
  alignRight = false,
  setWrapperRef,
  isMulti = true,
}) => {
  // Extract current value from searchFilters
  const rawValue = searchFilters?.[filterName]?.value;
  const initialValues = Array.isArray(rawValue)
    ? rawValue
    : rawValue !== undefined && rawValue !== null && rawValue !== ""
    ? [rawValue]
    : [];

  // Normalize options to ensure valid { label, value } array
  const formattedOptions = (options || []).map((opt) => ({
    label: opt?.label || opt?.name,
    value: opt?.value ?? opt?.id,
  }));

  // Find currently selected options
  const initialSelected = formattedOptions.filter((opt) =>
    initialValues.some((v) => String(v) === String(opt.value))
  );

  const [selectedOptions, setSelectedOptions] = useState(initialSelected);

  const handleApply = () => {
    if (!selectedOptions || selectedOptions.length === 0) {
      setSearchFilters((prev = {}) => {
        const updated = { ...prev };
        delete updated[filterName];
        return updated;
      });
    } else {
      const selectedValues = selectedOptions.map(
        (opt) => Number(opt.value) || opt.value
      );
      setSearchFilters((prev = {}) => ({
        ...prev,
        [filterName]: {
          filter_type: isMulti ? "one_of" : "equal_to",
          value: isMulti ? selectedValues : selectedValues[0],
        },
      }));
    }
    if (closeFilter) closeFilter();
  };

  return (
    <div
      className={`filter_wrapper${alignRight ? " filter_wrapper_align_right" : ""}`}
      ref={setWrapperRef}
    >
      <Select
        label={`Select ${columnName}`}
        placeholder="Search..."
        options={formattedOptions}
        value={isMulti ? selectedOptions : selectedOptions[0] || null}
        onChange={(opts) => {
          if (isMulti) {
            setSelectedOptions(opts || []);
          } else {
            setSelectedOptions(opts ? [opts] : []);
          }
        }}
        isMulti={isMulti}
        isSearch={true}
      />
      <div className="filter_buttons mt-3">
        <button type="button" onClick={closeFilter} className="btn-cancel">
          Cancel
        </button>
        <button type="button" onClick={handleApply} className="btn-apply">
          Apply
        </button>
      </div>
    </div>
  );
};

export default CostCenterFilterDropdown;
